import conf from '../config/api.js';
//import api_e_commerce from '../config/api_e_commerce.route.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'


function requestApi(options) {
    return new Promise((resolve, reject) => {
        Vue.axios({
            method: options.method,
            url: conf.server + options.url,
            params: options.params,
            data: options.form,
            headers: options.headers,
            withCredentials: true
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

async function getCategories() {
    try {
        let response = await requestApi({
            method: 'GET',
            url: '/api/categories',
            params: {},
            form: {},
            headers: { 'Content-Type': 'application/json' }
        });
        this.categories = response;

    } catch (error) {
        console.error('Erreur lors de la récupération des catégories:', error);
    }
}

async function getProductsByCategory() {
    let url = '/api/products';

    if (this.selectedCategory != 'all') {
        url = `/api/categories/${this.selectedCategory}/objects?type=product`;
    }

    try {
        let response = await requestApi({
            method: 'GET',
            url: url,
            headers: { 'Content-Type': 'application/json' },
            params: {},
        });

        let tmp = response.products.filter(p => p.array_options.options_disponible_ecommerce == "1");
        this.products = tmp;
    } catch (error) {
        console.error('Erreur lors de la récupération des produits:', error);
    }
}

async function getProductMarques() {
    try {
        let response = await requestApi({
            method: 'GET',
            url: '/api/products',
            params: {},
            form: {},
            headers: { 'Content-Type': 'application/json' }
        });

        let uniqueMarques = Array.from(new Set(response.marques.map(marque => marque)))
            .map(label => {
                return response.marques.find(marque => marque === label);
            });

        this.marques = uniqueMarques;

    } catch (error) {
        console.error('Erreur lors de la récupération des marques :', error);
    }
}

//Fonction génération de toaster erreur
function toasterError(content, title) {
    new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title) {
    new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster erreur
function toasterErrorTopRight(content, title) {
    new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'top-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccessTopRight(content, title) {
    new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'top-right'
    })
}

//Fonction de création de propale
async function createPropale(devisReference) {
    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/createPropaleEcommerce',
            form: { idTiers: vuexStorage.state.info.socId, devisReference: devisReference  }
        });

        return response;
    } catch (error) {
        console.error(error)
        if (error.response != undefined) {
            toasterError(`Impossible de créer le devis`, 'Création impossible');
        } else {
            toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
        }
    }
}

//Fonction de récupération de propale
async function loadPropale(idPropale) {
    try {
        let propale = await requestApi({
            method: 'GET',
            url: `/api/loadPropale/${idPropale}`,
            params: {},
            form: {},
            headers: { 'Content-Type': 'application/json' }
        })

        vuexStorage.commit("setCurrentPropale", propale)
        return propale
    } catch (error) {
        if (error.response != undefined) {
            toasterError(`Impossible de charger le devis`, 'Chargement impossible')
        } else {
            toasterError(`Le service est momentanément indisponible`, 'Service indisponible')
        }
    }
}

//Fonction d'ajout de ligne à une propale
async function addLinePropale(idPropale, product, ref) {
    let totalHt = Number.parseFloat(product.quantity * product.price).toFixed(2)
    var totalTva = Number.parseFloat(product.quantity * ((product.price * product.tva_tx) / 100)).toFixed(2)
    var totalTtc = Number.parseFloat(totalHt + totalTva).toFixed(2)
    let line = {
        fk_product: product.id,
        label: product.label,
        tva_tx: product.tva_tx,
        qty: product.quantity,
        price_ttc: product.price_ttc,
        desc: product.desc,
        description: product.description,
        product_desc: product.description,
        product_type: product.type,
        subprice: Number.parseFloat(product.price).toFixed(2),
        product_label: product.product_label,
        product_ref: product.product_ref,
        fk_remise_except: product.fk_remise_except,
        remise_percent: product.remise_percent,
        total_ht: totalHt,
        total_tva: totalTva,
        total_ttc: totalTtc,
        multicurrency_subprice : Number.parseFloat(product.price).toFixed(2),
        multicurrency_total_ht : totalHt,
        multicurrency_total_tva : totalTva,
        multicurrency_total_ttc : totalTtc,
        date_creation : moment().format("YYYY-MM-DD HH:mm:ss"),
    }

    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/addLinePropale',
            params: {},
            form: { id: idPropale, product: line },
            headers: { 'Content-Type': 'application/json' }
        });

        await requestApi({
            method: 'POST',
            url: '/api/rebuildDocPropaleEcommerce',
            params: {},
            form: { ref: ref },
            headers: { 'Content-Type': 'application/json' }
        });


        return response;
    } catch (error) {
        if (error.response !== undefined) {
            toasterError(`Impossible d'ajouter la ligne`, 'Ajout de ligne');
        } else {
            toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
        }
    }
}

//Fonction d'ajout de FDP à une propale
async function addFdpPropale(idPropale, fdp, ref) {
    try {
        let response = await requestApi({
            method: 'POST',
            url: '/api/addFdpPropale',
            params: {},
            form: { id: idPropale, fdp: fdp },
            headers: { 'Content-Type': 'application/json' }
        });

        await requestApi({
            method: 'POST',
            url: '/api/rebuildDocPropaleEcommerce',
            params: {},
            form: { ref: ref },
            headers: { 'Content-Type': 'application/json' }
        });


        return response;
    } catch (error) {
        if (error.response !== undefined) {
            toasterError(`Impossible d'ajouter la ligne`, 'Ajout de ligne');
        } else {
            toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
        }
    }
}


// Fonction asynchrone pour valider le panier et générer un devis
async function validerPanierEtGenererDevis() {
    try {

        // Récupération du panier depuis le stockage local
        const cartItemsString = localStorage.getItem('cart');
        const cartItems = cartItemsString ? JSON.parse(cartItemsString) : [];
        var poids = cartItems.reduce((totalWeight, item) => {
            return (totalWeight + (item.weight * item.quantity))/1000;
        }, 0);
        var fdp = 0
        if(poids<1){
            fdp = 1
        }else if((poids >= 1)&&(poids < 5)){
            fdp = 5
        }else if((poids >= 5)&&(poids <30)){
            fdp = 30
        }

        // Vérification si le panier est disponible et non vide
        if (cartItems.length === 0) {
            console.error("Le panier est vide.");
            return;
        }

        // Création de la proposition commerciale
        var response = await createPropale(this.devisReference);
        var idPropale = response.id;

        // Chargement de la propale créée pour vérification
        var propaleChargee = await loadPropale(idPropale);


        // Itération sur chaque produit du panier pour ajouter une ligne à la proposition commerciale
        for (let produit in cartItems) {
            try {
                // Supposition que `produit` contient toutes les informations nécessaires
                await addLinePropale(idPropale, cartItems[produit], propaleChargee.ref);
            } catch (erreur) {
                console.error("Erreur lors de l'ajout d'un produit à la propale :", erreur);
            }
        }

        try {
            await addFdpPropale(idPropale, fdp, propaleChargee.ref);

            try {
                await requestApi({
                    method: 'POST',
                    url: '/api/validateObjectEcommerce',
                    params: {},
                    form: {type: 'proposals', id: idPropale},
                    headers: { 'Content-Type': 'application/json' }
                });

                propaleChargee = await loadPropale(idPropale);
        
                await requestApi({
                    method: 'POST',
                    url: '/api/rebuildDocPropaleEcommerce',
                    params: {},
                    form: { ref: propaleChargee.ref },
                    headers: { 'Content-Type': 'application/json' }
                });
                try {
                    await requestApi({
                        method: 'POST',
                        url: `/api/sendPropale`,
                        params: {},
                        form: { id: idPropale, ref: propaleChargee.ref, socid: vuexStorage.state.info.socId, devisReference: this.devisReference },
                        headers: { 'Content-Type': 'application/json' }
                    })
                    this.cartItems = [];
                    localStorage.removeItem('cart');
                    this.devisReference = '';
                    toasterSuccess('Panier validé avec succès !');
                    return true
                } catch (error) {
                    console.error(error);
                }
            } catch (error) {
                console.error("Erreur lors de la validation de la propale", erreur);
            }
        } catch (erreur) {
            console.error("Erreur lors de l'ajout d'un produit à la propale :", erreur);
        }

        //await downloadPropale(propaleChargee.ref);        
    } catch (erreur) {
        console.error("Erreur lors de la validation du panier et de la génération du devis :", erreur);
    }
}

//Fonction récupération d'un tableau d'img
async function getImgProduct(ref){
    try {
        let response = await requestApi({method: 'GET',url: `/api/getAllImg/${ref}`,params: {},form: {},headers: { 'Content-Type': 'application/json' }})
        return response
    } catch (error) {
        console.log(error)
    }
}

//Fonction de récupération d'un produit
async function getProduct(id){
    try {
        var response = await requestApi({method: 'GET',url: `/api/getProductData/${id}`,params: {},form: {},headers: { 'Content-Type': 'application/json' }})
        console.log(response.suggestedProduct)
        this.product = response.product
        this.productSuggestions = response.suggestedProduct
    } catch (error) {
        console.log(error)
    }
}

//Fonction visualisation de doc tech et produit
async function visualDocPdf(doc){
    try {
        var response = await requestApi({method: 'GET',url: `/api/visualDocPdf/${doc}`,params: {},form: {},headers: { 'Content-Type': 'application/json' }})
        console.log(response)
    } catch (error) {
        console.log(error)
    }
}

export default {
    getCategories,
    getProductsByCategory,
    getProductMarques,
    validerPanierEtGenererDevis,
    toasterError,
    toasterSuccess,
    toasterErrorTopRight,
    toasterSuccessTopRight,
    createPropale,
    addLinePropale,
    addFdpPropale,
    getImgProduct,
    getProduct,
    visualDocPdf,
};
